import { Items } from 'components/hmilib/hmiclientbase';
import { EChartOption } from 'echarts';
import ReactEcharts from 'echarts-for-react';
import React, { useEffect } from 'react';
import { IAxisSetting, IConfig, IPens } from './../../index';
import './graph.css';

export interface IRefs {
    chartRef: React.RefObject<any>;
    scrollRefX: React.RefObject<HTMLDivElement>;
    scrollRefY: React.RefObject<HTMLDivElement>;
}

interface IGraph {
    refs: IRefs;
    data: any;
    pens: IPens[];
    config: IConfig;
    parentID: string;
    playStopDisplay: boolean;
    newSeriesPoints: any[];
    groupPensInfo?: any[];
    samplingPeriod?: any;
    selectedPen?: any;
    echarts_react?: any;
    notMerge?: boolean;
    calbacUpdateRow?: any;
    id?: string;
    onChartRef: (ref: any) => void;
    SetInterval: (check: boolean) => void;
}

export interface TrendHandle {
    handleReduceTimeAxis?: () => void;
}

const Graph = React.forwardRef<TrendHandle, IGraph>((props, forwardedRef) => {
    const {
        refs,
        data,
        pens,
        config,
        parentID,
        samplingPeriod,
        groupPensInfo,
        echarts_react,
        notMerge,
        calbacUpdateRow,
        id,
        onChartRef
    } = props;

    const dataline = {
        name: '',
        type: 'line',
        step: false,
        symbol: 'none',
        showSymbol: true,
        symbolSize: 3,
        lineStyle: { color: '#000', width: 1 },
        large: true,
        data: [],
        label: {},
        animation: false,
        markPoint: {}
    };

    const refDiv = React.useRef<HTMLDivElement>(null);
    const dataZoomRef = React.useRef<EChartOption.DataZoom[] | null>(null);
    const seriesRef = React.useRef<{}>();
    const [dataTime, setDataTime] = React.useState<any>();
    //Выбранный параметр для графика
    // const [selectedPens, setSelectedPens] = React.useState<string[]>([]);
    // let chartRef: EChartsReact | undefined = undefined;

    const tooltip = {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.45)',
        position: function (pos: any, params: any, el: any, elRect: any, size: any) {
            var obj: any = { top: 10 };
            obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
        },
        formatter: function (params: any) {
            params.sort(function (a: any, b: any) {
                return parseInt(b.value) - parseInt(a.value);
            });

            let output = '<b></b><br/>';

            if ((props.config.settings.chart.xAxis as IAxisSetting)?.type == 'time') {
                let d = new Date(params[0].value[0]);
                var datestring =
                    d.getDate() +
                    '/' +
                    (d.getMonth() + 1) +
                    '/' +
                    d.getFullYear() +
                    ' ' +
                    d.getHours() +
                    ':' +
                    d.getMinutes() +
                    ':' +
                    d.getSeconds();

                output = '<b>' + datestring + '</b><br/>';
            } else {
                output = '<b>' + params[0].value[0] + '</b><br/>';
            }

            for (let ipar = 0; ipar < params.length; ipar++) {
                //Проверка на не NaN, иначе график ломается? если на него наводишься
                if (!isNaN(params[ipar].value[1])) {
                    output += params[ipar].marker + params[ipar].seriesName + ': ' + params[ipar].value[1]?.toFixed(3);

                    if (ipar != params.length - 1) {
                        output += '<br/>';
                    }
                }
            }
            return output;
        },
        axisPointer: {
            animation: false
        }
    };

    const option_def: EChartOption = {
        grid: {
            right: 15,
            top: 20,
            bottom: 37,
            left: 0,
            show: true,
            backgroundColor: '#12161a'
        },
        brush: {
            toolbox: [],
            xAxisIndex: 'all',
            brushLink: 'all',
            outOfBrush: {
                colorAlpha: 0.2
            },
            throttleType: 'debounce'
        },
        xAxis: {
            type: 'time',
            silent: false,
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#2b4796'
                }
            },
            splitArea: {
                show: false
            },
            axisPointer: {
                snap: false,
                lineStyle: {
                    color: '#ffffff',
                    width: 2
                },
                label: {
                    show: false,
                    formatter: function (params: any) {
                        //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
                    },
                    backgroundColor: '#00CCFF'
                },
                handle: {
                    show: true,
                    icon: 'path://M0 0 L10 15 L20 0 Z',
                    color: '#00d4f6',
                    size: 15,
                    margin: -530
                }
            }
        },
        animation: false
    };

    const [option, setOption] = React.useState<EChartOption>({});

    const [zoomStartEnd, setZoomStartEnd] = React.useState({
        startX: 0,
        endX: 100,
        startY: 0,
        endY: 0
    });

    // React.useEffect(() => {
    //     const containerRectX = refs.scrollRefX.current?.parentElement?.clientWidth;
    //     const containerRectY = refs.scrollRefY.current?.parentElement?.clientHeight;
    //     const scrollWidth = refs.scrollRefX.current?.clientWidth;
    //     const scrollHeight = refs.scrollRefY.current?.clientHeight;
    //     const containerWidth = containerRectX || 0;
    //     const containerHeight = containerRectY || 0;

    //     // // Расчет начального положения скроллов и задание dataZoom
    //     if (scrollWidth && scrollHeight) {
    //         const initialXPosition = containerWidth - scrollWidth; // Положение скролла X справа
    //         const initialYPosition = (containerHeight - scrollHeight) / 2; // Центрирование скролла Y
    //         if (refs.scrollRefX.current && refs.scrollRefY.current) {
    //             refs.scrollRefX.current.style.left = `${initialXPosition}px`;
    //             refs.scrollRefY.current.style.top = `${initialYPosition}px`;
    //         }
    //         const startX = (initialXPosition / containerWidth) * 100;
    //         const endX = ((initialXPosition + scrollWidth) / containerWidth) * 100;
    //         const startY = ((containerHeight - initialYPosition - scrollHeight) / containerHeight) * 100;
    //         const endY = ((containerHeight - initialYPosition) / containerHeight) * 100;
    //         setZoomStartEnd({ startX: startX, endX: endX, startY: startY, endY: endY });
    //         props.SetInterval(true);
    //     }
    // }, []);

    React.useEffect(() => {
        const getOption = () => {
            let getOldOption = option;

            let newOption = option.grid ? getOldOption : option_def;

            let seriesall: any[] = [];
            let yAxisArr: any = [];

            let AxisIndex: number[] = [];

            let dataZoomArr: EChartOption.DataZoom[] = [
                {
                    start: 0,
                    end: 100,
                    xAxisIndex: 0,
                    show: false,
                    filterMode: 'none'
                },
                {
                    start: 0,
                    end: 100,
                    yAxisIndex: 0,
                    show: false,
                    filterMode: 'none'
                }
            ];

            let colors: string[] = [];

            let namesLegend = [];

            let formatterData = function (a: any) {
                return a.toFixed(1).toLocaleString();
            };

            for (let i = 0; i < props.pens.length; i++) {
                if ((props.pens[i].name != '' && props.pens[i].enable) || props.selectedPen == props.pens[i].name) {
                    let seriestemp = JSON.parse(JSON.stringify(dataline));

                    let name = props.pens[i].name;

                    if (props.data[name] && props.pens[i].enable) {
                        seriestemp.data = props.data[name];
                    } else {
                        seriestemp.data = [];
                    }

                    seriestemp.name = name;

                    namesLegend.push(name);

                    seriestemp.lineStyle.color = props.pens[i].color;

                    colors.push(props.pens[i].color);

                    if (props.pens[i].selected) {
                        seriestemp.lineStyle.width = 3;
                        seriestemp.symbolSize = 4;
                        // seriestemp.markLine.lineStyle.width = 3;
                    }

                    seriestemp.yAxisIndex =
                        props.pens[i].yAxisIndex != null ? props.pens[i].yAxisIndex : yAxisArr.length;
                    AxisIndex.push(seriestemp.yAxisIndex);

                    switch (props.pens[i].typeLine) {
                        case 'line': {
                            seriestemp.type = 'line';
                            // seriestemp.symbol = 'circle';
                            // seriestemp.symbolSize = 1;
                            break;
                        }
                        case 'linePoint': {
                            seriestemp.type = 'line';
                            seriestemp.symbol = 'circle';
                            seriestemp.symbolSize = props.pens[i].selected ? 12 : 10;
                            seriestemp.itemStyle = { color: props.pens[i].color };
                            break;
                        }
                        case 'point': {
                            seriestemp.type = 'scatter';
                            seriestemp.symbolSize = props.pens[i].selected ? 12 : 10;
                            seriestemp.symbol = 'circle';
                            seriestemp.lineStyle.opacity = 0;
                            seriestemp.itemStyle = { color: props.pens[i].color };
                            break;
                        }
                        case 'step': {
                            seriestemp.type = 'line';
                            seriestemp.step = 'end';
                            break;
                        }
                        case 'areadiscrete': {
                            seriestemp.type = 'line';
                            seriestemp.step = 'end';
                            seriestemp.symbol = 'none';
                            seriestemp.lineStyle.opacity = 0;
                            seriestemp.areaStyle = {
                                color: props.pens[i].color
                            };
                            break;
                        }
                        case 'radar': {
                            seriestemp.type = 'radar';
                            break;
                        }
                    }

                    seriestemp.encode = { x: 0, y: 1 };

                    seriestemp.label = {
                        show: false
                    };

                    seriesall.push(seriestemp);

                    if (props.pens[i].typeLine != 'radar' && seriestemp.yAxisIndex == yAxisArr.length) {
                        let showAxis = false;

                        if (props.selectedPen == props.pens[i].name) {
                            showAxis = true;
                        }

                        let formatterY = formatterData;
                        let yAxis = {
                            name: props.pens[i].name,
                            nameGap: 50,
                            nameLocation: 'middle',
                            nameTextStyle: {
                                fontSize: 15,
                                fontWeight: 'normal'
                            },
                            scrollbar: {
                                // show: showAxis ? true : false
                            },

                            type: 'value',
                            min: Number(props.pens[i].min),
                            max: Number(props.pens[i].max),
                            axisTick: {
                                // show: showAxis ? true : false
                            },
                            axisLabel: {
                                // show: showAxis ? true : false,
                                margin: 10,
                                fontSize: 16,
                                formatter: formatterY
                            },
                            axisLine: {
                                // show: showAxis ? true : false,
                                lineStyle: {
                                    color: props.pens[i].color
                                }
                            },
                            splitLine: {
                                // show: showAxis ? true : false,
                                interval: 4,
                                lineStyle: {
                                    color: '#2b4796'
                                }
                            },
                            minorSplitLine: {
                                // show: showAxis ? true : false,
                                interval: 1,
                                lineStyle: {
                                    color: '#2b4796',
                                    type: 'dashed'
                                }
                            },
                            show: showAxis ? true : false,
                            position: 'left',
                            animation: false,
                            offset: 0
                        };

                        yAxisArr.push(yAxis);
                    } else {
                        yAxisArr[seriestemp.yAxisIndex].min = Math.min(
                            yAxisArr[seriestemp.yAxisIndex].min,
                            Number(props.pens[i].min)
                        );
                        yAxisArr[seriestemp.yAxisIndex].max = Math.max(
                            yAxisArr[seriestemp.yAxisIndex].max,
                            Number(props.pens[i].max)
                        );
                    }
                }
            }

            let typeX =
                (props.config.settings.chart.xAxis as IAxisSetting) != undefined
                    ? ((props.config.settings.chart.xAxis as IAxisSetting).type as any)
                    : 'time';

            let formatterX = undefined;
            if (typeX != 'time') {
                formatterX = formatterData;
            }

            if ((props.config.settings.chart.xAxis as IAxisSetting)?.name) {
                if (newOption.grid) {
                    let name = (props.config.settings.chart.xAxis as IAxisSetting)?.name;
                    let nameLength = name?.length;
                    let rightValue = 25;

                    if (nameLength) {
                        rightValue += nameLength * 6;
                    }

                    newOption.grid = {
                        right: rightValue
                    };
                }
            }

            const containerRectX = refs.scrollRefX.current?.parentElement?.clientWidth;
            const containerRectY = refs.scrollRefY.current?.parentElement?.clientHeight;
            const scrollWidth = refs.scrollRefX.current?.clientWidth;
            const scrollHeight = refs.scrollRefY.current?.clientHeight;
            const containerWidth = containerRectX || 0;
            const containerHeight = containerRectY || 0;

            // // Расчет начального положения скроллов и задание dataZoom
            if (scrollWidth && scrollHeight) {
                const initialXPosition = containerWidth - scrollWidth; // Положение скролла X справа
                const initialYPosition = (containerHeight - scrollHeight) / 2; // Центрирование скролла Y
                if (refs.scrollRefX.current && refs.scrollRefY.current) {
                    refs.scrollRefX.current.style.left = `${initialXPosition}px`;
                    refs.scrollRefY.current.style.top = `${initialYPosition}px`;
                }
                const startX = (initialXPosition / containerWidth) * 100;
                const endX = ((initialXPosition + scrollWidth) / containerWidth) * 100;
                const startY = ((containerHeight - initialYPosition - scrollHeight) / containerHeight) * 100;
                const endY = ((containerHeight - initialYPosition) / containerHeight) * 100;
                setZoomStartEnd({ startX: startX, endX: endX, startY: startY, endY: endY });

                dataZoomArr = [
                    {
                        start: startX,
                        end: endX,
                        xAxisIndex: 0,
                        show: false,
                        filterMode: 'none'
                    },
                    {
                        start: startY,
                        end: endY,
                        yAxisIndex: AxisIndex,
                        show: false,
                        filterMode: 'none'
                    }
                ];
            }
            props.SetInterval(true);

            const instance = refs.chartRef.current.getEchartsInstance();
            const options = instance.getOption();
            // console.log(options);

            newOption = {
                ...newOption,
                color: colors,
                toolbox: {
                    show: false
                    //     trigger: 'axis',
                },
                tooltip: {
                    triggerOn: 'none',
                    show: false
                },
                grid: {
                    ...newOption.grid,
                    left: 100
                },
                radar: props.config.settings.chart.radar,
                xAxis: {
                    ...newOption.xAxis,
                    axisLabel: {
                        show: true,
                        formatter: formatterX
                    },
                    name: (props.config.settings.chart.xAxis as IAxisSetting)?.name,
                    min: (props.config.settings.chart.xAxis as IAxisSetting)?.min,
                    max: (props.config.settings.chart.xAxis as IAxisSetting)?.max,
                    type: typeX,
                    // axisPointer: option.grid ? options.xAxis[0].axisPointer : (typeof newOption.xAxis === 'object' &&!Array.isArray(newOption.xAxis)? newOption.xAxis?.axisPointer : undefined)
                    axisPointer: {
                        show: true,
                        type: 'line',
                        snap: true,

                        lineStyle: {
                            color: '#ffffff',
                            width: 2
                        },
                        label: {
                            show: false,
                            formatter: function (params: any) {
                                //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
                            },
                            backgroundColor: '#00CCFF'
                        },
                        handle: {
                            show: true,
                            icon: 'path://M0 0 L10 15 L20 0 Z',
                            color: '#00d4f6',
                            size: 15,
                            margin: -530
                        },
                        value: option.grid ? options.xAxis[0].axisPointer.value + samplingPeriod : new Date().getTime()
                    }
                },
                dataZoom: dataZoomArr,
                yAxis: yAxisArr,
                series: seriesall
            };

            return newOption;
        };

        let options = getOption();

        setOption(options);
    }, []);

    //Обновление и перестроение данных в графике
    React.useEffect(() => {
        const echartsInstance = refs.chartRef?.current.getEchartsInstance();
        let currentOptions = echartsInstance.getOption();

        if (currentOptions.yAxis && currentOptions.xAxis) {
            for (let i = 0; i < props.pens.length; i++) {
                if ((props.pens[i].name != '' && props.pens[i].enable) || props.selectedPen == props.pens[i].name) {
                    if (groupPensInfo) {
                        let pen = Items[groupPensInfo[i].penPath];

                        if (currentOptions.yAxis[i].min != pen.parameters.LOWLIMIT.CV)
                            currentOptions.yAxis[i].min = pen.parameters.LOWLIMIT.CV;
                        if (currentOptions.yAxis[i].max != pen.parameters.HIGHLIMIT.CV)
                            currentOptions.yAxis[i].max = pen.parameters.HIGHLIMIT.CV;
                    }
                }
            }

            if (props.playStopDisplay) {
                const now = new Date();
                const currentTimeInMilliseconds = now.getTime();
                currentOptions.xAxis[0].max = now;
                currentOptions.xAxis[0].axisPointer.value = currentTimeInMilliseconds;
            }

            const keys = Object.keys(props.data);
            keys.forEach((key, index) => {
                currentOptions.series[index].data.push(props.data[key][props.data[key].length - 1]);

                if (!props.pens[index].enable) {
                    currentOptions.series[index].type = 'custom';
                    currentOptions.series[index].renderItem = () => null;
                } else {
                    currentOptions.series[index].type = 'line';
                    delete currentOptions.series[index].renderItem;
                }
            });

            echartsInstance.setOption(currentOptions);
        }
    }, [props.newSeriesPoints, props.data]);

    //Обновление оси для выбранного пена
    React.useEffect(() => {
        const echartsInstance = refs.chartRef?.current.getEchartsInstance();
        let currentOptions = echartsInstance.getOption();

        for (let i = 0; i < props.pens.length; i++) {
            if (props.pens[i].name != '') {
                if (currentOptions.yAxis && currentOptions.xAxis) {
                    if (props.selectedPen == props.pens[i].name) {
                        currentOptions.yAxis[i].show = true;
                    } else {
                        currentOptions.yAxis[i].show = false;
                    }
                }
            }
        }

        echartsInstance.setOption(currentOptions);
    }, [props.selectedPen]);

    const isDraggingX = React.useRef(false);
    const isDraggingY = React.useRef(false);
    const prevMouseY = React.useRef<number>(0);

    const prevMouseX = React.useRef<number>(0);

    // Горизонтальный скролл
    React.useEffect(() => {
        const iframe = document.getElementById(parentID) as HTMLIFrameElement | null;
        if (iframe && iframe.contentWindow) {
            const handleMouseDownX = (event: MouseEvent) => {
                event.preventDefault();
                isDraggingX.current = true;
                prevMouseX.current = event.clientX;

                if (iframe.contentWindow) {
                    iframe.contentWindow.addEventListener('mousemove', handleMouseMoveX);
                    iframe.contentWindow.addEventListener('mouseup', handleMouseUpX);
                }
            };

            const handleMouseMoveX = (event: MouseEvent) => {
                event.preventDefault();
                if (isDraggingX.current && refs.scrollRefX.current) {
                    // const containerRectX = refs.scrollRefX.current.parentElement?.getBoundingClientRect();
                    const containerRectX = refs.scrollRefX.current.parentElement?.clientWidth;
                    const scrollWidth = refs.scrollRefX.current.clientWidth;
                    const containerWidth = containerRectX || 0;

                    // Calculate the ratio of the mouse movement relative to the viewport width
                    const viewportWidth = document.documentElement.clientWidth;
                    let deltaX = (event.clientX - prevMouseX.current) * (containerWidth / viewportWidth);

                    let left = refs.scrollRefX.current.offsetLeft + deltaX;
                    left = Math.max(0, left);
                    left = Math.min(containerWidth - scrollWidth, left);
                    refs.scrollRefX.current.style.left = `${left}px`;

                    const startX = (left / containerWidth) * 100;
                    const endX = ((left + scrollWidth) / containerWidth) * 100;

                    setZoomStartEnd((prevState) => ({
                        ...prevState,
                        startX: startX,
                        endX: endX
                    }));

                    if (refs.chartRef.current) {
                        const echartsInstance = refs.chartRef.current.getEchartsInstance();
                        echartsInstance.dispatchAction({
                            type: 'dataZoom',
                            start: startX,
                            end: endX,
                            dataZoomIndex: 0
                        });
                    }

                    prevMouseX.current = event.clientX;
                }
            };

            const handleMouseUpX = (event: MouseEvent) => {
                event.preventDefault();
                isDraggingX.current = false;

                if (iframe.contentWindow) {
                    iframe.contentWindow.removeEventListener('mousemove', handleMouseMoveX);
                    iframe.contentWindow.removeEventListener('mouseup', handleMouseUpX);
                }
            };

            if (refs.scrollRefX.current) {
                refs.scrollRefX.current.addEventListener('mousedown', handleMouseDownX);
            }

            return () => {
                if (refs.scrollRefX.current) {
                    refs.scrollRefX.current.removeEventListener('mousedown', handleMouseDownX);
                }
            };
        }
    }, [refs.scrollRefX, refs.chartRef]);

    const handleLeftClickX = () => {
        let scroll = 'scrollX';
        let button = 'left';
        SetScrollOption(scroll, button);
    };

    const handleRightClickX = () => {
        let scroll = 'scrollX';
        let button = 'right';
        SetScrollOption(scroll, button);
    };

    // Вертикальный скролл
    React.useEffect(() => {
        const iframe = document.getElementById(parentID) as HTMLIFrameElement | null;
        if (iframe && iframe.contentWindow) {
            const handleMouseDownY = (event: MouseEvent) => {
                event.preventDefault();
                isDraggingY.current = true;
                prevMouseY.current = event.clientY;
                if (iframe.contentWindow) {
                    iframe.contentWindow.addEventListener('mousemove', handleMouseMoveY);
                    iframe.contentWindow.addEventListener('mouseup', handleMouseUpY);
                }
            };

            const handleMouseMoveY = (event: MouseEvent) => {
                event.preventDefault();
                if (isDraggingY.current && refs.scrollRefY.current) {
                    const containerRectY = refs.scrollRefY.current.parentElement?.clientHeight;
                    const scrollHeight = refs.scrollRefY.current.clientHeight;
                    const containerHeight = containerRectY || 0;

                    let deltaY = event.clientY - prevMouseY.current;

                    let top = refs.scrollRefY.current.offsetTop + deltaY;
                    top = Math.max(0, top);
                    top = Math.min(containerHeight - scrollHeight, top);
                    refs.scrollRefY.current.style.top = `${top}px`;

                    const startY = ((containerHeight - top - scrollHeight) / containerHeight) * 100;
                    const endY = ((containerHeight - top) / containerHeight) * 100;

                    setZoomStartEnd((prevState) => ({
                        ...prevState,
                        startY: startY,
                        endY: endY
                    }));

                    if (refs.chartRef.current) {
                        const echartsInstance = refs.chartRef.current.getEchartsInstance();

                        echartsInstance.dispatchAction({
                            type: 'dataZoom',
                            start: startY,
                            end: endY,
                            dataZoomIndex: 1
                        });
                    }

                    prevMouseY.current = event.clientY;
                }
            };

            const handleMouseUpY = (event: MouseEvent) => {
                event.preventDefault();
                isDraggingY.current = false;

                if (iframe.contentWindow) {
                    iframe.contentWindow.removeEventListener('mousemove', handleMouseMoveY);
                    iframe.contentWindow.removeEventListener('mouseup', handleMouseUpY);
                }
            };

            if (refs.scrollRefY.current) {
                refs.scrollRefY.current.addEventListener('mousedown', handleMouseDownY);
            }

            return () => {
                if (refs.scrollRefY.current) {
                    refs.scrollRefY.current.removeEventListener('mousedown', handleMouseDownY);
                }
            };
        }
    }, [refs.scrollRefY, refs.chartRef]);

    const handleUpClickY = () => {
        let scroll = 'scrollY';
        let button = 'up';
        SetScrollOption(scroll, button);
    };

    const handleDownClickY = () => {
        let scroll = 'scrollY';
        let button = 'down';
        SetScrollOption(scroll, button);
    };

    const SetScrollOption = (scroll: any, button: any) => {
        if (refs.chartRef.current && refs.scrollRefY.current && refs.scrollRefX.current) {
            let start: any;
            let end: any;
            switch (scroll) {
                case 'scrollX':
                    const containerRectX = refs.scrollRefX.current.parentElement?.clientWidth;
                    const scrollWidth = refs.scrollRefX.current.clientWidth;
                    const containerWidth = containerRectX || 0;

                    if (button == 'left') {
                        refs.scrollRefX.current.style.left =
                            Math.max(0, parseInt(refs.scrollRefX.current.style.left) - 20) + 'px';
                    } else if (button == 'right') {
                        refs.scrollRefX.current.style.left =
                            Math.min(containerWidth - scrollWidth, parseInt(refs.scrollRefX.current.style.left) + 20) +
                            'px';
                    }

                    const left = parseInt(refs.scrollRefX.current.style.left);

                    start = (left / containerWidth) * 100;
                    end = ((left + scrollWidth) / containerWidth) * 100;

                    setZoomStartEnd((prevState) => ({
                        ...prevState,
                        startX: start,
                        endX: end
                    }));

                    break;

                case 'scrollY':
                    const containerRectY = refs.scrollRefY.current.parentElement?.clientHeight;
                    const scrollHeight = refs.scrollRefY.current.clientHeight;
                    const containerHeight = containerRectY || 0;

                    if (button == 'up') {
                        refs.scrollRefY.current.style.top =
                            Math.max(0, parseInt(refs.scrollRefY.current.style.top) - 20) + 'px';
                    } else if (button == 'down') {
                        refs.scrollRefY.current.style.top =
                            Math.min(containerHeight - scrollHeight, parseInt(refs.scrollRefY.current.style.top) + 20) +
                            'px';
                    }

                    const top = parseInt(refs.scrollRefY.current.style.top);

                    start = ((containerHeight - top - scrollHeight) / containerHeight) * 100;
                    end = ((containerHeight - top) / containerHeight) * 100;

                    setZoomStartEnd((prevState) => ({
                        ...prevState,
                        startY: start,
                        endY: end
                    }));

                    break;

                default:
                    break;
            }

            const echartsInstance = refs.chartRef.current.getEchartsInstance();

            const dataZoom = echartsInstance.getOption().dataZoom;
            if (dataZoom) {
                let index;
                if (scroll == 'scrollX') {
                    index = 0;
                } else if (scroll == 'scrollY') {
                    index = 1;
                }

                echartsInstance.dispatchAction({
                    type: 'dataZoom',
                    start: start,
                    end: end,
                    dataZoomIndex: index
                });
            }
        }
    };

    React.useEffect(() => {
        const mutationObserver = new MutationObserver(() => {
            const containerRectX = refs.scrollRefX.current?.parentElement;
            const containerWidth = containerRectX?.clientWidth || 0;
            const scrollWidth = refs.scrollRefX.current?.clientWidth;
            if (scrollWidth) {
                const iframe = document.getElementById(parentID) as HTMLIFrameElement | null;

                let leftPosition = containerWidth - scrollWidth;

                if (refs.scrollRefX.current?.offsetLeft === leftPosition) {
                    const scrollWidth = refs.scrollRefX.current.clientWidth;
                    const currentLeft = parseFloat(refs.scrollRefX.current.style.left || '0');

                    let left = refs.scrollRefX.current.offsetLeft;

                    let startX = (left / containerWidth) * 100;
                    let endX = ((left + scrollWidth) / containerWidth) * 100;

                    const echartsInstance = refs.chartRef.current.getEchartsInstance();
                    const dataZoom = echartsInstance.getOption().dataZoom;
                    if (dataZoom) {
                        if (endX > 100) endX = 100;
                        echartsInstance.dispatchAction({
                            type: 'dataZoom',
                            start: startX,
                            end: endX,
                            dataZoomIndex: 0
                        });
                    }

                    setZoomStartEnd((prevState) => ({
                        ...prevState,
                        startX: startX,
                        endX: endX
                    }));

                    props.SetInterval(true);
                } else {
                    props.SetInterval(false);
                }
            }
        });

        if (refs.scrollRefX.current) {
            mutationObserver.observe(refs.scrollRefX.current, {
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        }

        return () => {
            mutationObserver.disconnect();
        };
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                <div style={{ width: 'calc(100% - 15px)', height: '100%' }}>
                    <ReactEcharts
                        //   notMerge={props.notMerge}
                        notMerge={true}
                        lazyUpdate={true}
                        option={option}
                        // onEvents={onEvents}
                        style={{ height: '100%', width: '100%' }}
                        ref={refs.chartRef}
                        opts={{ locale: '' }}
                    />
                </div>

                <div className="scroll-y-container">
                    <button className="up-scroll-button" onClick={handleUpClickY}>
                        <svg width="6" height="6" viewBox="0 0 6 6">
                            <polygon points="0,6 3,0 6,6" fill="black" />
                        </svg>
                    </button>
                    <div
                        className="main-scroll-y"
                        style={{ height: 'calc(100% - 30px)', width: '100%', position: 'relative' }}>
                        {/* <div ref={refs.scrollRefY} style={{ position: 'absolute',top:0, bottom: 0, left: 0, height: '198px', width: '13px', background: '#d4d0c8', cursor: 'pointer',}}></div> */}
                        <div
                            ref={refs.scrollRefY}
                            style={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                height: '35%',
                                width: '13px',
                                background: '#d4d0c8',
                                cursor: 'pointer'
                            }}></div>
                    </div>
                    <button className="down-scroll-button" onClick={handleDownClickY}>
                        <svg width="6" height="6" viewBox="0 0 6 6">
                            <polygon points="0,0 3,6 6,0" fill="black" />
                        </svg>
                    </button>
                </div>
            </div>

            <div className="scroll-x-container" style={{ width: 'calc(100% - 15px' }}>
                <button className="left-scroll-button" onClick={handleLeftClickX}>
                    <svg width="6" height="6" viewBox="0 0 6 6">
                        <polygon points="0,3 6,0 6,6" fill="black" />
                    </svg>
                </button>
                <div className="main-scroll-x" style={{ width: 'calc(100% - 30px)', position: 'relative' }}>
                    {/* <div ref={refs.scrollRefX} style={{position: 'absolute',top: 0, bottom: 0, left: 0, height: '13px', width: '198px', background: '#d4d0c8', cursor: 'pointer'}}></div> */}
                    <div
                        ref={refs.scrollRefX}
                        style={{
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            left: 0,
                            height: '13px',
                            width: '15%',
                            background: '#d4d0c8',
                            cursor: 'pointer'
                        }}></div>
                </div>
                <button className="right-scroll-button" onClick={handleRightClickX}>
                    <svg width="6" height="6" viewBox="0 0 6 6">
                        <polygon points="0,0 6,3 0,6" fill="black" />
                    </svg>
                </button>
            </div>
        </div>
    );
});

export default Graph;
